module.exports = __webpack_public_path__ + "img/“.53279bb9.svg";